import axios from "axios";

export default class IpGeolocationHelper {
  static ipApiTable = ['https://api.ipify.org/?format=json', 'https://api.my-ip.io/ip.json'];
  static locationApiTable = ['http://ip-api.com/json/{{ip}}', 'https://ipwhois.app/json/{{ip}}', 'https://ipapi.co/{{ip}}/json/'];

  static statesMap: Record<string, string> = {
    'Acre': 'AC',
    'Alagoas': 'AL',
    'Amapá': 'AP',
    'Amazonas': 'AM',
    'Bahia': 'BA',
    'Ceará': 'CE',
    'Distrito Federal': 'DF',
    'Espírito Santo': 'ES',
    'Goiás': 'GO',
    'Maranhão': 'MA',
    'Mato Grosso': 'MT',
    'Mato Grosso do Sul': 'MS',
    'Minas Gerais': 'MG',
    'Pará': 'PA',
    'Paraíba': 'PB',
    'Paraná': 'PR',
    'Pernambuco': 'PE',
    'Piauí': 'PI',
    'Rio de Janeiro': 'RJ',
    'Rio Grande do Norte': 'RN',
    'Rio Grande do Sul': 'RS',
    'Rondônia': 'RO',
    'Roraima': 'RR',
    'Santa Catarina': 'SC',
    'São Paulo': 'SP',
    'Sergipe': 'SE',
    'Tocantins': 'TO'
  };

  static getUserIp(): Promise<any> {
    return new Promise((resolve) => {      
      IpGeolocationHelper.ipApiTable.forEach(async (hostApi) => {          
        const { data } = await axios.get(hostApi);
        if ( data.ip ) {
          resolve(data.ip);
        }
      });
    });
  }

  static async getUserLocation(usrIp: string | null) {
    const userIp = usrIp ?? (await IpGeolocationHelper.getUserIp());
    const maxRandomRange = IpGeolocationHelper.locationApiTable.length - 1;
    let apiOptions = [];  
    let currentApiIndex = Math.floor(Math.random() * (maxRandomRange + 1));
    let formatedResponse: any = {};

    for (let index = 0; index <= maxRandomRange; index++) {
      if (index != currentApiIndex)
        apiOptions.push(index);
    }

    do {
      let currentApi = IpGeolocationHelper.locationApiTable[currentApiIndex];
      currentApi = currentApi.replace('{{ip}}', userIp);
      const responseLocation = await axios.get(currentApi);
      formatedResponse = IpGeolocationHelper.formatResponseByLocationApi(currentApiIndex, responseLocation.data);
      currentApiIndex = apiOptions[Math.floor(Math.random() * apiOptions.length)];
      apiOptions = apiOptions.filter( el => {return el != currentApiIndex});
    } while(apiOptions.length > 0 && (!formatedResponse.state || !formatedResponse.city));
    
    return formatedResponse;
  }

  static formatResponseByLocationApi(apiIndex: number, responseData: any) {
    switch (apiIndex) {
      case 0: {
        // url: http://ip-api.com/json/{{ip}}
        return {state: responseData.region, city: responseData.city};
      }
      case 1: {
        // url: https://ipwhois.app/json/{{ip}}
        const sanitizedRegion: any = responseData.region.replace('State of ', '');
        const state = IpGeolocationHelper.statesMap[sanitizedRegion as string] as string;
        return {state: state, city: responseData.city};
      }
      case 2: {
        // url: https://ipapi.co/{{ip}}/json/
        return {state: responseData.region_code, city: responseData.city};
      }
      default: 
        return {};
    }
  }
}